import axios from 'axios'
import store from '../store'

const http = axios.create({
  baseURL: 'https://ver2.viamenus.com'
})

http.interceptors.request.use(config => {
  store.dispatch('loading/startRequest')
  return config
})

http.interceptors.response.use(
  response => {
    store.dispatch('loading/finishRequest')
    return response
  },
  error => {
    store.dispatch('loading/finishRequest')
    return Promise.reject(error)
  }
)

export default http